/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/naming-convention */
import DateTextField from '@brands/Components/Inputs/MuiDateTextField/DateTextField';
import MultiSelectInputMUI from '@brands/Components/Inputs/MuiMultiSelectInput/MultiSelectInputMUI';
import MUISelectInput from '@brands/Components/Inputs/MuiSelectInput/MUISelectInput';
import PhoneInput from '@brands/Components/Inputs/MuiTelInput/MuiTelInput';
import TextField from '@brands/Components/Inputs/MuiTextField/TextField';
import MuiToggle from '@brands/Components/Inputs/MuiToggle/MuiToggle';
import { Loading } from '@brands/Components/LoadingSpinner/Loading';
import UnsavedChangesModal from '@brands/Dashboard/Dashboard/Components/UnsavedChangesModal/UnsavedChangesModal';
import InsuranceFormSection from '@brands/Dashboard/Insurance/InsuranceFormSection';
import { UploadedFile } from '@brands/Dashboard/MyProfile/Patient/utils/utilsFunctions';
import { useAppDispatch, useAppSelector } from '@brands/hooks/useReduxHook';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { useUnsavedChangesWarning } from '@brands/hooks/useUnsavedChangesWarning';
import { CaseType } from '@brands/services/cases/types/ICase';
import { createPatientInsurance } from '@brands/services/identity/createPatientInsurance';
import { deactivateInsuranceById } from '@brands/services/identity/deactivatePatientInsurance';
import { getPatientInsurance } from '@brands/services/identity/getPatientInsurance';
import { Pricings } from '@brands/services/identity/getPricings';
import { getUserById } from '@brands/services/identity/getUserById';
import { Insurance as InsuranceType, InsuranceMedia, Language } from '@brands/services/identity/types/UserProfile';
import { UpdateMe, updateMe } from '@brands/services/identity/updateMe';
import { confirmOneReportMedia } from '@brands/services/oneReport/confirmOneReportMedia';
import { getOneReportMedia } from '@brands/services/oneReport/getOneReportMedia';
import { registerOneReportMedia } from '@brands/services/oneReport/registerOneReportMedia';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectOrganization } from '@brands/store/selectors/organization';
import { selectOrganizationPrices } from '@brands/store/selectors/organizationPrices';
import { selectPageState } from '@brands/store/selectors/pageState';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { selectPatient } from '@brands/store/selectors/selectedPatient';
import { addDependent, updateDependent as editDependent } from '@brands/store/slices/dependentsSlice';
import { setDependentId, setIsFromSelectPatient } from '@brands/store/slices/pageStateSlice';
import { setExternalForms, setSelectedPatient } from '@brands/store/slices/patientFormSlice';
import { setSelectedPatientByAdmin } from '@brands/store/slices/selectedPatientSlice';
import { base64ListToFileList } from '@brands/Utils/base64ToFile';
import { checkExternalFormAnswers } from '@brands/Utils/checkExternalForms';
import { displayErrorDetails, withoutErrorCode } from '@brands/Utils/displayError';
import { isFree, needsPayment } from '@brands/Utils/needsPayment';
import { getFileMimeType } from '@brands/Utils/truncateString';
import { UnifiedProfileSubmit } from '@brands/Utils/types';
import { validateAddress, ValidationModalInterface } from '@brands/Utils/validateAddress';
import { yupResolver } from '@hookform/resolvers/yup';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { AlertColor, Button, Checkbox, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { heicTo } from 'heic-to';
import { E164Number, parsePhoneNumber } from 'libphonenumber-js';
import { isEqual } from 'lodash';
import moment from 'moment';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useForm, UseFormGetValues, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { AiOutlineClose } from 'react-icons/ai';
import { FiMinus, FiPlus } from 'react-icons/fi';
import { useLocation } from 'react-router-dom';
import { MultiValue } from 'react-select';
import { toast } from 'react-toastify';
import {
  InsuranceForm,
  InsuranceImages,
  InsuranceMediaContent,
} from 'src/brands/dentistry-one/Dashboard/Insurance/utils/types';

import ConfirmationModal from '../../../../../Components/Modals/ConfirmationModal/ConfirmationModal';
import ProfileImage from '../../../../../Components/ProfileImage/ProfileImage';
import { RegisterMediaPayload } from '../../../../../services/communication/registersConversationMedia';
import { confirmAvatarMedia } from '../../../../../services/identity/confirmAvatarMedia';
import { createBasicInformation } from '../../../../../services/identity/createBasicInformation';
import { createDependent } from '../../../../../services/identity/createDependent';
import { deleteAvatar } from '../../../../../services/identity/deleteAvatar';
import { deleteCollectorDependent } from '../../../../../services/identity/deleteCollectorDependent';
import { deleteDependent } from '../../../../../services/identity/deleteDependent';
import { getDependentById } from '../../../../../services/identity/getDependentById';
import { registerAvatarMedia } from '../../../../../services/identity/registerAvatarMedia';
import { saveBasicInformation } from '../../../../../services/identity/saveBasicInformation';
import { Dependent } from '../../../../../services/identity/types/Dependent';
import {
  Address,
  BasicInfo,
  Insurance,
  Marker,
  UserProfile,
  UserRoleName,
} from '../../../../../services/identity/types/UserProfile';
import { updateDependent } from '../../../../../services/identity/updateDependent';
import { addPlanMember } from '../../../../../services/patient_plan/services';
import { GroupSummary } from '../../../../../services/patient_plan/types/types';
import { genderIdentity, genderOptions, pronounsOptions } from '../../../../../Utils/selectButtonOptions';
import { insuranceThroughOptions, OptionLanguage } from '../../../../../Utils/selectOptions';
import { updateDataInsuranceNewDesign, updateDataSecondaryInsuranceNewDesign } from '../../utils/utilsFunctions';
import { dependentValidationSchemaNewDesign } from '../../utils/validationSchema';
import styles from '../Profile/styles.module.scss';
import AddressSection from './AddressSection/AddressSection';
import back from './BackToPrimaryProfile.svg';

function addressFieldValue(value: unknown): string {
  return String(value ?? '').trim();
}

export type DependentPatientSubmit = {
  profile_img: string | null;
  first_name: string;
  preferred_name: string;
  middle_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  zip_code: string;
  state: string;
  date_of_birth: string;
  pronouns: string;
  gender: string;
  gender_identity: string;
  address1: string;
  address2: string;
  city: string;
  country: string;
  profileAddress: string;
  profileCity: string;
  languages?: Language[] | string[];
  language: MultiValue<OptionLanguage> | string[];
  id: number;
  patientId: number;
  guardian_relationship: string;
  dependent_email: string;
  member_id: string;
  group_number?: string;
  insurance_through: string;
  insurance_carrier_id?: number;
  state_funded_coverage_status?: string;
  is_secondary?: boolean;
  secondary_group_number?: string;
  secondary_member_id: string;
  secondary_insurance_phone_number: string;
  secondary_insurance_through: string;
  secondary_insurance_carrier_id?: number;
  insurance_address?: string;
  insurance_city?: string;
  insurance_state?: string;
  insurance_zip_code?: string;
  insurance_first_name: string;
  insurance_date_of_birth: string;
  insurance_gender: string;
  insurance_last_name: string;
  insurance_address1: string;
  insurance_address2: string;
  insurance_zip_code1: string;
  insurance_state1: string;
  insurance_city1: string;
  front_of_card: UploadedFile[];
  back_of_card: UploadedFile[];

  secondary_insurance_first_name: string;
  secondary_insurance_date_of_birth: string;
  secondary_insurance_gender: string;
  secondary_insurance_last_name: string;
  secondary_insurance_address1: string;
  secondary_insurance_address2: string;
  secondary_insurance_zip_code1: string;
  secondary_insurance_state1: string;
  secondary_insurance_city1: string;
  secondary_insurance_address: string;
  secondary_insurance_city: string;
  secondary_insurance_state: string;
  secondary_insurance_zip_code: string;

  secondary_front_of_card: UploadedFile[];
  secondary_back_of_card: UploadedFile[];

  media?: InsuranceMedia[];
  insurance_phone_number: string;
  markers: Marker[];
};

type EditDependentProps = {
  setIsEditDependent: React.Dispatch<React.SetStateAction<boolean>>;
  dependentId?: number | undefined;
  languageOptions: OptionLanguage[];
  isModal?: boolean;
  validationResponseId: string;
  setValidationResponseId: React.Dispatch<React.SetStateAction<string>>;
  isFromSelectNeeds: boolean | undefined;
  showDeleteDependentConfirmationModal?: boolean;
  setShowDeleteDependentConfirmationModal?: React.Dispatch<React.SetStateAction<boolean>>;
  showSnackbar: (message: string, type?: AlertColor) => void;
  isFromPatientIntake?: boolean;
  patientPlanId?: number | undefined;
  onGroupUpdated?: (next: GroupSummary) => void;
  /** Collector “add dependent” modal: skip patient-intake navigation and Redux selected-patient overwrite. */
  isFromCollectorAddDependent?: boolean;
  onCollectorDependentCreated?: (dependentId: number, isNew: boolean) => void;
};

export const relationshipOptions = [
  { value: 'parent', label: 'Parent' },
  { value: 'stepparent', label: 'Stepparent' },
  { value: 'sibling', label: 'Sibling' },
  { value: 'aunt_uncle', label: 'Aunt/Uncle' },
  { value: 'grandparent', label: 'Grandparent' },
  { value: 'appointed_guardian', label: 'Appointed Guardian' },
  { value: 'other', label: 'Other' },
];

const EditDependent = ({
  setIsEditDependent,
  dependentId,
  languageOptions,
  isModal,
  validationResponseId,
  setValidationResponseId,
  isFromSelectNeeds,
  showDeleteDependentConfirmationModal,
  setShowDeleteDependentConfirmationModal,
  showSnackbar,
  isFromPatientIntake = false,
  patientPlanId = undefined,
  onGroupUpdated = () => {},
  isFromCollectorAddDependent = false,
  onCollectorDependentCreated,
}: EditDependentProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const formRef = useRef<HTMLFormElement | null>(null);
  const hasFetchedDependentRef = useRef(false);
  const hasFetchedGuardianRef = useRef(false);
  const { state } = useLocation();
  const { selectedPatient } = useAppSelector(selectPatient);
  const { values } = useAppSelector(selectPatientForm);
  const [avatarPayload, setAvatarPayload] = useState<RegisterMediaPayload | null>(null);
  const { userInfo } = useAppSelector(selectAuth);
  const guardianUserIdForDependentOperations =
    userInfo.role.name === UserRoleName.Admin ||
    userInfo.role.name === UserRoleName.SuperAdmin ||
    userInfo.role.name === UserRoleName.OrganizationAdmin ||
    userInfo.role.name === UserRoleName.Collector ||
    userInfo.role.name === UserRoleName.CareAdvisor
      ? selectedPatient.guardian_id != null
        ? selectedPatient.guardian_id
        : selectedPatient.id
      : userInfo.id;
  const [fetchLoading, setFetchLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const { currentOrganization } = useAppSelector(selectOrganization);
  const organizationPrices = useAppSelector(selectOrganizationPrices);
  const { isFromSelectPatient, isEditInsuranceFlag } = useAppSelector(selectPageState);
  const [guardianPatient, setGuardianPatient] = useState<UserProfile>();
  const [avatarFile, setAvatarFile] = useState<File | null>(null);
  const [isSavingProfile, setIsSavingProfile] = useState(false);
  const [image, setImage] = useState<string | undefined>(undefined);
  const [avatarAction, setAvatarAction] = useState<string>('');
  const [patientInsurance, setPatientInsurance] = useState<Insurance[]>([]);
  const [addSecondaryInsurance, setAddSecondaryInsurance] = useState(false);
  /** False until initial values are applied; keeps Save disabled on first paint (watch() vs baseline mismatch). */
  const [dependentFormBaselineReady, setDependentFormBaselineReady] = useState(false);
  const prevDependentIdForBaselineRef = useRef<number | null>(null);
  const roleNavigate = useRoleNavigate();
  const [key, setKey] = useState(0);
  const phoneInputRef = useRef<HTMLInputElement>(null);
  const [dependentProfileForm, setDependentProfileForm] = useState<DependentPatientSubmit>({
    first_name: '',
    preferred_name: '',
    profile_img: '',
    middle_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    zip_code: '',
    state: '',
    date_of_birth: '',
    pronouns: '',
    gender_identity: '',
    gender: '',
    address1: '',
    address2: '',
    city: '',
    country: '',
    profileAddress: '',
    profileCity: '',
    language: [],
    languages: [],
    id: 0,
    patientId: 0,
    guardian_relationship: '',
    dependent_email: '',
    group_number: '',
    insurance_through: '',
    insurance_carrier_id: 0,
    secondary_group_number: '',
    insurance_address: '',
    insurance_city: '',
    insurance_state: '',
    insurance_zip_code: '',
    secondary_member_id: '',
    secondary_insurance_phone_number: '',
    secondary_insurance_through: '',
    secondary_insurance_carrier_id: undefined,
    insurance_first_name: '',
    insurance_date_of_birth: '',
    insurance_gender: '',
    insurance_last_name: '',
    insurance_address1: '',
    insurance_address2: '',
    insurance_zip_code1: '',
    state_funded_coverage_status: '',
    insurance_state1: '',
    insurance_city1: '',
    front_of_card: [],
    back_of_card: [],
    secondary_insurance_first_name: '',
    secondary_insurance_date_of_birth: '',
    secondary_insurance_gender: '',
    secondary_insurance_last_name: '',
    secondary_insurance_address1: '',
    secondary_insurance_address2: '',
    secondary_insurance_zip_code1: '',
    secondary_insurance_state1: '',
    secondary_insurance_city1: '',
    secondary_insurance_address: '',
    secondary_insurance_city: '',
    secondary_insurance_state: '',
    secondary_insurance_zip_code: '',
    insurance_phone_number: '',
    member_id: '',
    markers: [],
    secondary_front_of_card: [],
    secondary_back_of_card: [],

    media: [],
  });
  const [showValidationAddressModal, setShowValidationAddressModal] = useState<ValidationModalInterface>({
    isOpen: false,
    title: '',
    whatYouEntered: '',
    recommended: false,
    recommendedAddress: '',
    onClose: undefined,
    onConfirmChange: undefined,
    onKeepCurrentAddress: undefined,
  });

  const [isDragging, setIsDragging] = useState(false);
  const [images, setImages] = useState<InsuranceImages>({
    front_of_card: [],
    back_of_card: [],
    secondary_front_of_card: [],
    secondary_back_of_card: [],
  });

  const scrollToTop = (): void => {
    const el = document.getElementById('patientDashboardPosition');

    if (el) {
      el.scrollTo({ top: 0, behavior: 'smooth' });
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    if (hasFetchedDependentRef.current) return;
    hasFetchedDependentRef.current = true;

    const fetchData = async (): Promise<void> => {
      const isAdmin = [
        UserRoleName.Admin,
        UserRoleName.SuperAdmin,
        UserRoleName.OrganizationAdmin,
        UserRoleName.Collector,
      ].includes(userInfo.role.name);

      const actingUserId = isAdmin ? selectedPatient.guardian_id ?? selectedPatient.id : userInfo.id;

      try {
        if (!dependentId) {
          setInitialValuesNewDependent();
        } else {
          const isPatient = userInfo.role.name === UserRoleName.Patient;
          const isCollector = userInfo.role.name === UserRoleName.Collector;
          const loadAsDependentProfile = isPatient || isCollector;

          if (loadAsDependentProfile) {
            fetchUserInsurance();
          }

          const profile = loadAsDependentProfile
            ? await getDependentById(actingUserId, dependentId, userInfo.role.name)
            : await getUserById(dependentId);

          if (profile) {
            dispatch(setSelectedPatientByAdmin({ selectedPatient: profile }));
          }
        }

        if (!hasFetchedGuardianRef.current) {
          hasFetchedGuardianRef.current = true;

          if (isAdmin && selectedPatient.guardian_id) {
            const guardian = (await getUserById(selectedPatient.guardian_id)) as UserProfile;

            setGuardianPatient(guardian);
          } else if (userInfo.role.name === UserRoleName.Patient) {
            setGuardianPatient(userInfo);
          } else if (userInfo.role.name === UserRoleName.Collector || userInfo.role.name === UserRoleName.CareAdvisor) {
            setGuardianPatient(selectedPatient as UserProfile);
          }
        }
      } catch (error) {
        console.error('Failed to fetch dependent, user, or guardian', error);
        displayErrorDetails(error);
      }
    };

    fetchData();
  }, [dependentId]);

  useEffect(() => {
    const id = dependentId ?? null;
    if (prevDependentIdForBaselineRef.current !== null && prevDependentIdForBaselineRef.current !== id) {
      setDependentFormBaselineReady(false);
    }
    prevDependentIdForBaselineRef.current = id;
  }, [dependentId]);

  useEffect(() => {
    if (!selectedPatient) return;
    if (dependentId && Number(selectedPatient.id) !== Number(dependentId)) return;
    if (dependentId) void setInitialValues(selectedPatient as UserProfile, patientInsurance);
  }, [patientInsurance, selectedPatient, dependentId]);

  let currentOrganizationPrice: any;

  if (isFromSelectPatient) {
    currentOrganizationPrice = organizationPrices?.currentOrganizationPrices?.find(
      (currentOrganizationPrise: Pricings) =>
        currentOrganizationPrise.case_types.includes(
          values.find((item) => item.form_question_id === 20)?.value.caseType as string,
        ),
    );
  }
  const dependentValidationSchema = useMemo(
    () => dependentValidationSchemaNewDesign(addSecondaryInsurance),
    [addSecondaryInsurance],
  );

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    watch,
    formState: { errors },
    getValues,
  } = useForm<DependentPatientSubmit>({
    mode: 'onChange',
    resolver: yupResolver(dependentValidationSchema),
  });

  const { showModal, confirmNavigation, saveChanges, handleBlockedNavigation, hideModal } = useUnsavedChangesWarning(
    !isFromPatientIntake &&
      !isFromCollectorAddDependent &&
      !(isEqual(dependentProfileForm, getValues()) && isEqual(avatarAction, '')),
    formRef,
  );
  const selectSameAsGuardian = (isSelect = true): void => {
    const inputList = ['address1', 'address2', 'city', 'state', 'zip_code'];
    if (isSelect) {
      inputList.forEach((input) => {
        setValue(
          input as keyof DependentPatientSubmit,
          guardianPatient?.address?.[input as keyof Address]
            ? (guardianPatient?.address?.[input as keyof Address] as string)
            : '',
          {
            shouldValidate: true,
          },
        );
      });
    } else {
      inputList.forEach((input) => {
        setValue(input as keyof DependentPatientSubmit, input === 'state' ? undefined : '', {
          shouldValidate: true,
        });
        setKey((prev) => prev + 1);
      });
    }
  };

  const removeSecondaryInsurance = async (secondaryInsuranceId: number): Promise<void> => {
    try {
      await deactivateInsuranceById(secondaryInsuranceId);
      const userInsurance = await getPatientInsurance(dependentId);
      setPatientInsurance(userInsurance);
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
  };

  const triggerProfileAvatar = React.useCallback((avatarUrl: string) => {
    setValue('profile_img', avatarUrl, { shouldValidate: true });
    setDependentProfileForm({
      ...watch(),
      profile_img: avatarUrl,
    });
  }, []);

  const deleteSelectedDependent = async (): Promise<void> => {
    try {
      if (userInfo.role.name === UserRoleName.Collector) {
        await deleteCollectorDependent(guardianUserIdForDependentOperations, dependentId as number);
      } else {
        await deleteDependent(guardianUserIdForDependentOperations, dependentId as number);
      }
      setIsEditDependent(false);
      dispatch(
        editDependent({
          value: dependentId?.toString(),
          label: `${dependentProfileForm.first_name} ${dependentProfileForm.last_name}`,
          status: 'Deactivated',
        }),
      );
      if (userInfo.id) {
        dispatch(
          setSelectedPatient({
            value: userInfo.id.toString(),
            label: 'Myself',
          }),
        );
      }
    } catch (error: any) {
      const { status, data } = error.response;
      if (status === 400 || status === 422) {
        toast.error(withoutErrorCode(data.message));
      }
    }
  };
  const onCloseConfirmationModal = (): void => {
    setShowValidationAddressModal({
      isOpen: false,
      title: '',
      whatYouEntered: '',
      recommended: false,
      recommendedAddress: '',
      onClose: undefined,
      onConfirmChange: undefined,
      onKeepCurrentAddress: undefined,
    });
    setShowDeleteDependentConfirmationModal && setShowDeleteDependentConfirmationModal(false);
  };

  const onContinueConfirmationModal = (): void => {
    setShowDeleteDependentConfirmationModal && setShowDeleteDependentConfirmationModal(false);
    deleteSelectedDependent();
  };

  const checkExternalForms = async (selectedPatientId: number, updatedUser: UserProfile): Promise<string[]> => {
    const [checkProfile, checkMedicalHistory, checkMedicalConditionsFormAnswer, checkDentalHistoryFormAnswer] =
      await checkExternalFormAnswers(
        userInfo.role.name === UserRoleName.Admin ||
          userInfo.role.name === UserRoleName.SuperAdmin ||
          userInfo.role.name === UserRoleName.OrganizationAdmin ||
          userInfo.role.name === UserRoleName.Collector
          ? guardianPatient ?? (updatedUser as UserProfile)
          : userInfo,
        updatedUser,
      );

    const formsToSet: string[] = [];

    if (!checkProfile) {
      formsToSet.push('patient_profile');
    }
    if (!checkMedicalHistory) {
      formsToSet.push('patient_medical_history');
    }
    if (!checkMedicalConditionsFormAnswer) {
      formsToSet.push('patient_medical_conditions');
    }
    if (!checkDentalHistoryFormAnswer) {
      formsToSet.push('patient_dental_history');
    }

    dispatch(setExternalForms(formsToSet));
    return formsToSet;
  };

  const fetchData = (selectedPatientId: number, updatedUser: UserProfile): Promise<string[]> => {
    setFetchLoading(true);
    return checkExternalForms(selectedPatientId, updatedUser);
  };

  const uploadMedia = async (imagesValue: UploadedFile[]): Promise<string[]> => {
    let imageList: string[] = [];

    if (Array.isArray(imagesValue)) {
      imageList = imagesValue.map((i) => {
        if (typeof i === 'string') {
          return i;
        }
        return i.dataURL;
      });
    }
    const fileList = await base64ListToFileList(imageList || []);

    const mediaIDs: string[] = [];

    if (Array.isArray(imagesValue) && Array.isArray(fileList)) {
      await Promise.all(
        Array.from(fileList).map(async (file, index) => {
          const i = imagesValue[index] as UploadedFile;
          const mimeType = getFileMimeType(i.name);
          const payload: RegisterMediaPayload = {
            files: [
              {
                filename: i.name,
                mimetype: mimeType,
              },
            ],
          };
          try {
            const registeredMedia = await registerOneReportMedia(payload, userInfo.role.name);
            const mediaId = registeredMedia.files[0].upload_id;
            await fetch(registeredMedia.files[0].upload_url, {
              method: 'PUT',
              body: file,
              headers: { 'content-type': mimeType },
            });
            await confirmOneReportMedia(mediaId, userInfo.role.name);
            mediaIDs.push(mediaId);
          } catch (error: unknown) {
            displayErrorDetails(error);
          }
        }),
      );
    }
    return mediaIDs;
  };

  const mapMediaToInsuranceMedia = (media: string[], type: string): InsuranceMedia[] => {
    return media.map((mediaId) => ({ media_id: mediaId, type }));
  };

  const callSaveProfile = async (profileData: UnifiedProfileSubmit): Promise<void> => {
    setIsSavingProfile(true);
    setLoading(true);
    let id;
    let updatedUser: UserProfile | undefined;
    try {
      if (!dependentId) {
        const res = await createDependent(
          guardianUserIdForDependentOperations,
          {
            guardian_relationship: (profileData as DependentPatientSubmit).guardian_relationship!,
            email: (profileData as DependentPatientSubmit).dependent_email || null,
          },
          { userRole: userInfo.role.name },
        );
        id = res.id;
        if (isFromSelectNeeds) {
          dispatch(
            setSelectedPatient({
              value: res.id.toString(),
              label: res.full_name,
            }),
          );
          dispatch(setSelectedPatientByAdmin({ selectedPatient: res }));
        }
      } else {
        id = dependentId;
        const res = await updateDependent(
          guardianUserIdForDependentOperations,
          id,
          {
            guardian_relationship: (profileData as DependentPatientSubmit).guardian_relationship,
            email: (profileData as DependentPatientSubmit).dependent_email || null,
          },
          { userRole: userInfo.role.name },
        );
        if (isFromSelectNeeds) {
          dispatch(
            setSelectedPatient({
              value: res.id.toString(),
              label: res.full_name,
            }),
          );
        }
      }
      if (avatarPayload && avatarFile && avatarAction === 'Upload') {
        const res = await registerAvatarMedia(avatarPayload, userInfo.role.name);
        const mediaId = res.files[0].upload_id;
        await fetch(res.files[0].upload_url, {
          method: 'PUT',
          body: avatarFile,
          headers: { 'content-type': avatarFile.type },
        });
        await confirmAvatarMedia(mediaId, id, undefined, userInfo.role.name);
        triggerProfileAvatar(res.files[0].upload_url);
      } else if (avatarAction === 'Remove') {
        await deleteAvatar(id);
        triggerProfileAvatar('');
      }

      updatedUser = await updateMe(
        {
          ...(profileData as UpdateMe),
          ...(profileData.phone_number && {
            phone_number: parsePhoneNumber(profileData.phone_number, 'US')?.format('E.164') as string,
          }),
          address: {
            address1: profileData.address1,
            address2: profileData.address2,
            city: profileData.city,
            state: profileData.state,
            zip_code: profileData.zip_code,
          },
        },
        id || 0,
        userInfo.role.name === UserRoleName.Collector ? 'Collector' : undefined,
      );

      const setPayload = (data: DependentPatientSubmit): BasicInfo => {
        const { date_of_birth, first_name, preferred_name, last_name, middle_name, gender, pronouns, gender_identity } =
          data;

        const basicInfoPayload: BasicInfo = {
          date_of_birth: date_of_birth ? moment(date_of_birth).format('YYYY-MM-DD') : '',
          first_name: first_name as string,
          preferred_name: preferred_name as string,
          last_name: last_name as string,
          middle_name: middle_name as string,
          gender: gender as string,
          ...(pronouns && { pronouns }),
          gender_identity: gender_identity as string,
          languages: (profileData as DependentPatientSubmit).language.map((language) =>
            typeof language === 'object' && 'id' in language ? language.id.toString() : language.toString(),
          ),
        };
        return basicInfoPayload;
      };

      const collectorBasicInfoRole = userInfo.role.name === UserRoleName.Collector ? 'Collector' : undefined;
      if (dependentId) {
        updatedUser = await saveBasicInformation(
          setPayload(profileData as DependentPatientSubmit),
          id,
          collectorBasicInfoRole,
        );
      } else {
        updatedUser = await createBasicInformation(
          setPayload(profileData as DependentPatientSubmit),
          id,
          collectorBasicInfoRole,
        );
      }

      // Client tags on dependents are inherited server-side; the API rejects writes.

      if ((profileData as DependentPatientSubmit).insurance_through?.toLowerCase() !== 'none') {
        const insuranceArray: InsuranceType[] = [];

        let front_of_card_media_ids: string[] = [];
        let back_of_card_media_ids: string[] = [];
        await Promise.all([
          (front_of_card_media_ids = await uploadMedia((profileData as DependentPatientSubmit).front_of_card)),
          (back_of_card_media_ids = await uploadMedia((profileData as DependentPatientSubmit).back_of_card)),
        ]);

        const dataWithUpdatedInsurance = updateDataInsuranceNewDesign(profileData as DependentPatientSubmit);

        dataWithUpdatedInsurance.front_of_card = mapMediaToInsuranceMedia(front_of_card_media_ids, 'front_of_card');
        dataWithUpdatedInsurance.back_of_card = mapMediaToInsuranceMedia(back_of_card_media_ids, 'back_of_card');

        insuranceArray.push(dataWithUpdatedInsurance);
        if (addSecondaryInsurance) {
          let secondary_front_of_card_media_ids: string[] = [];
          let secondary_back_of_card_media_ids: string[] = [];
          await Promise.all([
            (secondary_front_of_card_media_ids = await uploadMedia(
              (profileData as DependentPatientSubmit).secondary_front_of_card,
            )),
            (secondary_back_of_card_media_ids = await uploadMedia(
              (profileData as DependentPatientSubmit).secondary_back_of_card,
            )),
          ]);

          const dataWithUpdatedSecondaryInsurance = updateDataSecondaryInsuranceNewDesign(
            profileData as DependentPatientSubmit,
          );

          dataWithUpdatedSecondaryInsurance.front_of_card = mapMediaToInsuranceMedia(
            secondary_front_of_card_media_ids,
            'front_of_card',
          );
          dataWithUpdatedSecondaryInsurance.back_of_card = mapMediaToInsuranceMedia(
            secondary_back_of_card_media_ids,
            'back_of_card',
          );
          dataWithUpdatedSecondaryInsurance.is_secondary = true;
          insuranceArray.push(dataWithUpdatedSecondaryInsurance);
        }

        await createPatientInsurance({
          user_id: id,
          insurance: insuranceArray,
        });
      } else {
        for (const insurance of patientInsurance) {
          if (!insurance?.id) continue;

          await deactivateInsuranceById(insurance.id);
        }
      }
      showSnackbar('Your changes have been saved', 'success');
      if (!dependentId) {
        dispatch(
          addDependent({
            value: id.toString(),
            label: `${profileData.first_name} ${profileData.last_name}`,
            status: 'Active',
          }),
        );
      } else {
        dispatch(
          editDependent({
            value: id.toString(),
            label: `${profileData.first_name} ${profileData.last_name}`,
            status: 'Active',
          }),
        );
      }
      if (patientPlanId) {
        const updated = await addPlanMember(patientPlanId, { user_id: id as number });
        onGroupUpdated?.(updated);
      }
      if (isFromCollectorAddDependent && onCollectorDependentCreated && id != null) {
        onCollectorDependentCreated(id, !dependentId);
      }
      if (setIsEditDependent) setIsEditDependent(false);
    } catch (error: unknown) {
      displayErrorDetails(error);
    } finally {
      setIsSavingProfile(false);
      setLoading(false);
      // A failed save leaves updatedUser unset; dispatching it anyway would
      // wipe the redux patient selection (the reducer replaces blindly) and
      // crash the render-time guardian_id deref for staff roles.
      if (updatedUser && !isFromCollectorAddDependent) {
        dispatch(setSelectedPatientByAdmin({ selectedPatient: updatedUser as UserProfile }));
      }

      if (updatedUser && isFromSelectPatient && !isFromCollectorAddDependent) {
        fetchData(id || 0, updatedUser as UserProfile);
        dispatch(setIsFromSelectPatient(false));

        if (!isFromPatientIntake) {
          const caseType = values.find((item) => item.form_question_id === 20)?.value.caseType as string;

          if (caseType === CaseType.clinical_enablement) {
            // Resume where SelectPatient sends this case type when the
            // profile was already complete: photos, then the medical-history
            // steps. Payment comes after DescribePainLevel, so going to
            // payment first (or to the catch-all below) would skip both.
            roleNavigate('/upload-image', {
              state: {
                caseType,
                patientState: userInfo.address?.state,
                userOrganization: currentOrganization.id,
                patientId: userInfo.id,
              },
            });
          } else if (needsPayment(currentOrganizationPrice)) {
            roleNavigate('/payment-information', {
              state: { caseType },
            });
          } else if (caseType === CaseType.oral_health_coaching) {
            // Coaching is booked with a care advisor, not a provider: same next step SelectPatient
            // takes when the profile was already complete.
            roleNavigate('/select-care-advisor', {
              state: {
                caseType,
                insuranceCarrierId: '',
                customInsuranceCarrier: '',
                userOrganization: currentOrganization.id,
                patientId: userInfo.id,
              },
            });
          } else if (caseType === 'video_call_scheduled' || caseType === CaseType.phone_call_scheduled) {
            roleNavigate('/select-provider', {
              state: {
                caseType,
                insuranceCarrierId: '',
                customInsuranceCarrier: '',
                userOrganization: currentOrganization.id,
                patientId: userInfo.id,
              },
            });
          } else if (caseType === 'second_opinion') {
            roleNavigate('/clinical-data', {
              state: {
                caseType,
                patientState: userInfo.address?.state,
                userOrganization: currentOrganization.id,
                patientId: userInfo.id,
              },
            });
          } else if (caseType === CaseType.care_coordination && isFree(currentOrganizationPrice)) {
            roleNavigate('/select-patient', {
              state: { caseType },
            });
          } else {
            roleNavigate('/describe-pain-level', {
              state: {
                caseType,
                patientState: userInfo.address?.state,
                userOrganization: currentOrganization.id,
                patientId: userInfo.id,
              },
            });
          }
        } else {
          roleNavigate('/select-patient', { state: { newDependentId: id } });
        }
      }
    }
  };

  const updateCurrentAddress = (standardizedAddress: any, postalAddress: any, addressComponents: any): void => {
    const streetNumber = addressComponents.find(
      (addressComponent: any) => addressComponent.componentType === 'street_number',
    );
    const address1 = addressComponents.find((addressComponent: any) => addressComponent.componentType === 'route');
    if (postalAddress) setValue('city', postalAddress.locality, { shouldValidate: true });
    if (streetNumber || address1) {
      setValue('address1', `${streetNumber.componentName.text} ${address1.componentName.text}`, {
        shouldValidate: true,
      });
    }
    if (standardizedAddress?.state) setValue('state', standardizedAddress.state, { shouldValidate: true });
    if (postalAddress) setValue('zip_code', postalAddress.postalCode, { shouldValidate: true });
  };

  const onSubmit = async (profileData: DependentPatientSubmit): Promise<void> => {
    await validateAddress(
      profileData,
      getValues as UseFormGetValues<UnifiedProfileSubmit>,
      validationResponseId,
      callSaveProfile,
      setValidationResponseId,
      setShowValidationAddressModal,
      onCloseConfirmationModal,
      updateCurrentAddress,
    );
  };

  const onInvalid = (errorsList: any): void => {
    const error = Object.values(errorsList)[0] as any;
    if (error) {
      toast.error(error.message as string);
    }
  };

  const onCancelEditDependent = (): void => {
    handleBlockedNavigation(() => {
      setIsEditDependent(false);

      if (isFromSelectPatient) {
        dispatch(setIsFromSelectPatient(false));
        dispatch(setDependentId(null));

        roleNavigate('/select-patient', {
          state: {
            caseType: values.find((item) => item.form_question_id === 20)?.value.caseType as string,
          },
        });
      }
    });
  };

  useEffect(() => {
    if (image) triggerProfileAvatar(image);
  }, [image]);

  const convertResponseToFormData = (data: Dependent): DependentPatientSubmit => {
    const { id, guardian_relationship, basic_info, picture_media_id, patient_profile, ...rest } = data;
    const primaryInsurance = patientInsurance?.find((i) => !i.is_secondary);
    const secondaryInsurance = patientInsurance?.find((i) => i.is_secondary);
    const dependentData: DependentPatientSubmit = {
      ...rest,
      profile_img: '',
      first_name: basic_info?.first_name,
      preferred_name: basic_info?.preferred_name || '',
      middle_name: basic_info?.middle_name || '',
      last_name: basic_info?.last_name,
      email: rest.email || '',
      phone_number: rest.phone_number || '',
      zip_code: data?.address?.zip_code,
      state: data?.address?.state,
      date_of_birth: basic_info?.date_of_birth ? moment(basic_info.date_of_birth).format('MM/DD/YYYY') : '',
      pronouns: basic_info?.pronouns || '',
      gender_identity: basic_info?.gender_identity || '',
      gender: basic_info?.gender,
      address1: data?.address?.address1,
      address2: data?.address?.address2 || '',
      city: data?.address?.city,
      country: data?.address?.country,
      profileAddress: data?.address?.address1,
      profileCity: data?.address?.city,
      id,
      patientId: id,
      guardian_relationship: guardian_relationship || '',
      dependent_email: rest.email || '',
      language:
        basic_info?.languages
          ?.map((language) => languageOptions.find((option) => option.label === language.name))
          .filter((option): option is OptionLanguage => option !== null && option !== undefined) ||
        ([] as MultiValue<OptionLanguage>),
      state_funded_coverage_status:
        patientInsurance && primaryInsurance ? primaryInsurance.state_funded_coverage_status : '',
      insurance_through: patientInsurance && primaryInsurance?.insured_by ? primaryInsurance.insured_by : 'none',
      member_id:
        patientInsurance && primaryInsurance?.insurance_membership
          ? primaryInsurance?.insurance_membership.member_id
          : '',
      group_number:
        patientInsurance && primaryInsurance?.insurance_membership
          ? primaryInsurance?.insurance_membership.group_number
          : '',
      insurance_address:
        patientInsurance && primaryInsurance?.insurance_membership
          ? primaryInsurance?.insurance_membership.address?.address1
          : '',
      insurance_city:
        patientInsurance && primaryInsurance?.insurance_membership
          ? primaryInsurance?.insurance_membership.address?.city
          : '',
      insurance_state:
        patientInsurance && primaryInsurance?.insurance_membership
          ? primaryInsurance?.insurance_membership.address?.state
          : '',
      insurance_zip_code:
        patientInsurance && primaryInsurance?.insurance_membership
          ? primaryInsurance?.insurance_membership.address?.zip_code
          : '',
      insurance_first_name: (patientInsurance && primaryInsurance?.insurance_through?.first_name) || '',
      insurance_last_name: (patientInsurance && primaryInsurance?.insurance_through?.last_name) || '',
      insurance_date_of_birth:
        patientInsurance && primaryInsurance?.insurance_through
          ? moment(primaryInsurance?.insurance_through?.date_of_birth).format('MM/DD/YYYY')
          : '',
      insurance_gender: (patientInsurance && primaryInsurance?.insurance_through?.gender_identity) || '',
      insurance_address1: (patientInsurance && primaryInsurance?.insurance_through?.address?.address1) || '',
      insurance_address2: (patientInsurance && primaryInsurance?.insurance_through?.address?.address2) || '',
      insurance_zip_code1: (patientInsurance && primaryInsurance?.insurance_through?.address?.zip_code) || '',
      insurance_state1: (patientInsurance && primaryInsurance?.insurance_through?.address?.state) || '',
      insurance_city1: (patientInsurance && primaryInsurance?.insurance_through?.address?.city) || '',
      insurance_phone_number:
        patientInsurance && primaryInsurance?.insurance_membership
          ? primaryInsurance?.insurance_membership.phone_number
          : '',
      insurance_carrier_id: patientInsurance && primaryInsurance?.insurance_membership?.insurance_carrier_id,
      front_of_card: [] as UploadedFile[],
      back_of_card: [] as UploadedFile[],
      secondary_insurance_through:
        patientInsurance && secondaryInsurance?.insured_by ? secondaryInsurance.insured_by : '',
      secondary_member_id:
        patientInsurance && secondaryInsurance?.insurance_membership
          ? secondaryInsurance.insurance_membership.member_id
          : '',
      secondary_group_number:
        patientInsurance && secondaryInsurance?.insurance_membership
          ? secondaryInsurance.insurance_membership.group_number
          : '',
      secondary_insurance_address:
        patientInsurance && secondaryInsurance?.insurance_membership
          ? secondaryInsurance.insurance_membership?.address?.address1 || ''
          : '',
      secondary_insurance_city:
        patientInsurance && secondaryInsurance?.insurance_membership
          ? secondaryInsurance.insurance_membership?.address?.city || ''
          : '',
      secondary_insurance_state:
        patientInsurance && secondaryInsurance?.insurance_membership
          ? secondaryInsurance.insurance_membership?.address?.state || ''
          : '',
      secondary_insurance_zip_code:
        patientInsurance && secondaryInsurance?.insurance_membership
          ? secondaryInsurance.insurance_membership?.address?.zip_code || ''
          : '',
      secondary_insurance_first_name: (patientInsurance && secondaryInsurance?.insurance_through?.first_name) || '',
      secondary_insurance_last_name: (patientInsurance && secondaryInsurance?.insurance_through?.last_name) || '',
      secondary_insurance_date_of_birth:
        patientInsurance && secondaryInsurance?.insurance_through
          ? moment(secondaryInsurance?.insurance_through?.date_of_birth).format('MM/DD/YYYY')
          : '',
      secondary_insurance_gender: (patientInsurance && secondaryInsurance?.insurance_through?.gender_identity) || '',
      secondary_insurance_address1:
        (patientInsurance && secondaryInsurance?.insurance_through?.address?.address1) || '',
      secondary_insurance_address2:
        (patientInsurance && secondaryInsurance?.insurance_through?.address?.address2) || '',
      secondary_insurance_zip_code1:
        (patientInsurance && secondaryInsurance?.insurance_through?.address?.zip_code) || '',
      secondary_insurance_state1: (patientInsurance && secondaryInsurance?.insurance_through?.address?.state) || '',
      secondary_insurance_city1: (patientInsurance && secondaryInsurance?.insurance_through?.address?.city) || '',
      secondary_insurance_phone_number:
        patientInsurance && secondaryInsurance?.insurance_membership
          ? secondaryInsurance.insurance_membership.phone_number
          : '',
      secondary_insurance_carrier_id:
        (patientInsurance && secondaryInsurance?.insurance_membership?.insurance_carrier_id) || undefined,
      secondary_front_of_card: [] as UploadedFile[],
      secondary_back_of_card: [] as UploadedFile[],
    };

    return dependentData;
  };

  const loadImages = async (media_list: InsuranceMedia[]): Promise<InsuranceMediaContent[]> => {
    const imagePromises = media_list.map(async (mediaOneReport: InsuranceMedia) => {
      const mediaData = await getOneReportMedia(mediaOneReport.media_id!);
      return {
        src: mediaData.url,
        width: 4,
        height: 3,
        type: mediaOneReport.type,
        dataURL: mediaData.url,
        media_id: mediaOneReport.media_id,
        name: mediaData.filename,
      } as InsuranceMediaContent;
    });
    const imagesList = await Promise.all(imagePromises);
    return imagesList;
  };

  const setInitialValues = async (data: Dependent | UserProfile, patientInsuranceGiven: Insurance[]): Promise<void> => {
    const baselineLockDependentId = dependentId;
    const dependentData = convertResponseToFormData(data as Dependent);
    if (Object.keys(dependentData).length > 0) {
      Object.keys(dependentData).forEach((k) => {
        setValue(k as keyof DependentPatientSubmit, dependentData[k as keyof DependentPatientSubmit]);
      });
    }

    const imagesObj: InsuranceImages = {
      front_of_card: [],
      back_of_card: [],
      secondary_front_of_card: [],
      secondary_back_of_card: [],
    };

    // Primary insurance (index 0)
    if (patientInsuranceGiven[0]?.media) {
      const { media } = patientInsuranceGiven[0];
      const frontOfCard = media.filter((m) => m.type === 'front_of_card');
      const backOfCard = media.filter((m) => m.type === 'back_of_card');

      if (frontOfCard.length || backOfCard.length) {
        const mediaList = [...frontOfCard, ...backOfCard];
        const medias = await loadImages(mediaList);

        imagesObj.front_of_card = medias.filter((img) => img.type === 'front_of_card');
        imagesObj.back_of_card = medias.filter((img) => img.type === 'back_of_card');
      }
    }

    // Secondary insurance (index 1)
    if (patientInsuranceGiven[1]?.media) {
      const { media } = patientInsuranceGiven[1];
      const frontOfCard = media.filter((m) => m.type === 'front_of_card');
      const backOfCard = media.filter((m) => m.type === 'back_of_card');

      if (frontOfCard.length || backOfCard.length) {
        const mediaList = [...frontOfCard, ...backOfCard];
        const medias = await loadImages(mediaList);

        imagesObj.secondary_front_of_card = medias.filter((img) => img.type === 'front_of_card');
        imagesObj.secondary_back_of_card = medias.filter((img) => img.type === 'back_of_card');
      }
    }

    // set form + state
    setImages(imagesObj);
    setValue('front_of_card', imagesObj.front_of_card);
    setValue('back_of_card', imagesObj.back_of_card);
    setValue('secondary_front_of_card', imagesObj.secondary_front_of_card);
    setValue('secondary_back_of_card', imagesObj.secondary_back_of_card);

    const mergedData = {
      ...dependentData,
      front_of_card: imagesObj.front_of_card,
      back_of_card: imagesObj.back_of_card,
      secondary_front_of_card: imagesObj.secondary_front_of_card,
      secondary_back_of_card: imagesObj.secondary_back_of_card,
    };

    setDependentProfileForm(mergedData);
    if (baselineLockDependentId !== dependentId) return;
    setDependentFormBaselineReady(true);
  };

  const setInitialValuesNewDependent = (): void => {
    if (Object.keys(dependentProfileForm).length > 0) {
      Object.keys(dependentProfileForm).forEach((k: unknown) => {
        setValue(k as keyof DependentPatientSubmit, dependentProfileForm[k as keyof DependentPatientSubmit]);
      });
    }
    setDependentProfileForm(dependentProfileForm);
    setDependentFormBaselineReady(true);
  };
  const fetchUserInsurance = async (): Promise<void> => {
    if (dependentId) {
      const userInsurance = await getPatientInsurance(dependentId);
      setPatientInsurance(userInsurance);
      setAddSecondaryInsurance(!!userInsurance.find((i) => i.is_secondary));
    }
  };

  useEffect(() => {
    hasFetchedGuardianRef.current = false;
    if (selectedPatient?.address === null) {
      selectSameAsGuardian();
    }
    scrollToTop();
  }, []);

  const setTextValue = (e: React.ChangeEvent<HTMLInputElement>, name: string): void => {
    const { value } = e.target;
    setValue(name as keyof DependentPatientSubmit, value, { shouldValidate: true });
  };

  const addImages = (files: File[], type: keyof InsuranceImages): void => {
    const newImages = files.filter(
      (file) =>
        file.type.startsWith('image/') ||
        file.type === 'application/pdf' ||
        file.type === 'application/msword' ||
        file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        file.type === 'application/vnd.ms-powerpoint' ||
        file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    );
    if (getValues(type).length + files.length > 10) {
      displayErrorDetails('Max 10 files are allowed to upload.');
      return;
    }
    const imagesArray: UploadedFile[] = [];
    for (let i = 0; i < newImages.length; i++) {
      const file = newImages[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.addEventListener('load', () => {
        imagesArray.push({ name: file.name, dataURL: reader.result as string });
        if (imagesArray.length === newImages.length) {
          setValue(type, imagesArray, { shouldValidate: true });
          setImages({
            ...images,
            [type]: imagesArray,
          });
        }
      });
    }
  };

  const deleteMedia = (mediaName: string, type: string | number | symbol): void => {
    const k = type as keyof InsuranceImages;
    const selectedMedia = getValues(k).find((i) => i.name === mediaName);
    if (selectedMedia) {
      setValue(
        k,
        getValues(k).filter((i) => i.name !== mediaName),
        { shouldValidate: true },
      );
      setImages({
        ...images,
        [k]: images[k].filter((i) => i.name !== mediaName),
      });
    }
  };

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
    const files = Array.from(event.target.files as unknown as File[]);
    const convertedFiles = await Promise.all(
      files.map(async (file) => {
        if (file.type === 'image/heic') {
          try {
            const jpegBlob = await heicTo({
              blob: file,
              type: 'image/jpeg',
              quality: 0.85,
            });

            return new File([jpegBlob], file.name.replace(/\.heic$/i, '.jpeg'), {
              type: 'image/jpeg',
            });
          } catch (error: any) {
            displayErrorDetails(`Error converting HEIC to JPEG: ${error}`);
            return file;
          }
        }

        return file;
      }),
    );

    addImages(convertedFiles, event.target.id as keyof InsuranceImages);
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>): void => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = async (event: React.DragEvent<HTMLDivElement>, type: keyof InsuranceImages): Promise<void> => {
    event.preventDefault();
    setIsDragging(false);

    if (!event.dataTransfer.files?.length) return;
    let file = event.dataTransfer.files[0];

    if (file.type === 'image/heic') {
      try {
        const jpegBlob = await heicTo({
          blob: file,
          type: 'image/jpeg',
          quality: 0.85,
        });
        file = new File([jpegBlob], file.name.replace(/\.heic$/i, '.jpeg'), {
          type: 'image/jpeg',
        });
      } catch (error: any) {
        displayErrorDetails(`Error converting HEIC to JPEG: ${error}`);
      }
    }

    addImages([file], type);
  };

  const handleDragEnter = (event: React.DragEvent<HTMLDivElement>): void => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (event: React.DragEvent<HTMLDivElement>): void => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
  };

  if (loading) {
    return (
      <div className={styles.ProfileDiv}>
        <Loading fullScreen />
      </div>
    );
  }

  const isSameAddressAsGuardian =
    Boolean(guardianPatient?.address?.address1) &&
    addressFieldValue(watch('address1')) === addressFieldValue(guardianPatient?.address?.address1) &&
    addressFieldValue(watch('address2')) === addressFieldValue(guardianPatient?.address?.address2) &&
    addressFieldValue(watch('city')) === addressFieldValue(guardianPatient?.address?.city) &&
    addressFieldValue(watch('state')) === addressFieldValue(guardianPatient?.address?.state) &&
    addressFieldValue(watch('zip_code')) === addressFieldValue(guardianPatient?.address?.zip_code);

  return (
    <>
      {!isModal && !isFromSelectPatient ? (
        <div className={styles.backToPrimaryProfileBtn}>
          <button type="button" className={styles.backBtn} onClick={onCancelEditDependent}>
            <img src={back} />
            Back to Primary Profile
          </button>
        </div>
      ) : isModal ? (
        <button className={styles.closeBtn} onClick={onCancelEditDependent} aria-label="Close" type="button">
          <AiOutlineClose />
        </button>
      ) : (
        <div className={styles.backToPrimaryProfileBtn}>
          <button type="button" className={styles.backBtn} onClick={onCancelEditDependent}>
            <img src={back} />
            Back to select patient
          </button>
        </div>
      )}
      <div
        className={`${isFromPatientIntake && styles.editProfileContainerPatientIntake} ${styles.editProfileContainer}`}
      >
        <div className={styles.editContainer}>
          <div className={`d-flex justify-content-between ${styles.mobileFlexCol}`}>
            <ProfileImage
              id={dependentId ? dependentId.toString() : undefined}
              setAvatarFile={setAvatarFile}
              setAvatarPayload={setAvatarPayload}
              setAvatarAction={setAvatarAction}
              setImage={setImage}
              image={image}
              size="80px"
              isNewDependent={!dependentId}
              givingUserProfile={dependentProfileForm}
            />
          </div>
          <form ref={formRef} className={`${styles.formContainer}`} onSubmit={handleSubmit(onSubmit, onInvalid)}>
            <div className={styles.inputWrapRow}>
              <div className={styles.inputWrap}>
                <TextField
                  {...register('first_name')}
                  label="First name"
                  value={watch('first_name')}
                  data-testid="dependent-first-name"
                  errors={errors.first_name ? errors : {}}
                  name="first_name"
                  onChange={(e: any) => {
                    if (errors.first_name) clearErrors('first_name');
                    setValue('first_name', e.target.value, { shouldValidate: true });
                  }}
                  required
                  inputClass={`${styles.profileInputClass} fs-exclude`}
                  wrapperClassName={`fs-unmask ${styles.completeProfileClass}`}
                />
              </div>
              <div className={styles.inputWrap}>
                <TextField
                  {...register('middle_name')}
                  label="Middle name (optional)"
                  data-testid="dependent-middle-name"
                  errors={errors.middle_name ? errors : {}}
                  value={watch('middle_name')}
                  name="middle_name"
                  onChange={(e: any) => {
                    if (errors.middle_name) clearErrors('middle_name');
                    setValue('middle_name', e.target.value, { shouldValidate: true });
                  }}
                  inputClass={`${styles.profileInputClass} fs-exclude`}
                  wrapperClassName={`fs-unmask ${styles.completeProfileClass}`}
                />
              </div>
              <div className={styles.inputWrap}>
                <TextField
                  {...register('last_name')}
                  label="Last name"
                  data-testid="dependent-last-name"
                  value={watch('last_name')}
                  errors={errors.last_name ? errors : {}}
                  name="last_name"
                  onChange={(e: any) => {
                    if (errors.last_name) clearErrors('last_name');
                    setValue('last_name', e.target.value, { shouldValidate: true });
                  }}
                  required
                  inputClass={`${styles.profileInputClass} fs-exclude`}
                  wrapperClassName={`fs-unmask ${styles.completeProfileClass}`}
                />
              </div>
            </div>
            <div className={styles.inputWrapRow}>
              <div className={styles.inputWrap}>
                <TextField
                  {...register('preferred_name')}
                  label="Preferred name (optional)"
                  data-testid="dependent-preferred-name"
                  value={watch('preferred_name')}
                  errors={errors.preferred_name ? errors : {}}
                  name="preferred_name"
                  onChange={(e: any) => {
                    if (errors.preferred_name) clearErrors('preferred_name');
                    setValue('preferred_name', e.target.value, { shouldValidate: true });
                  }}
                  inputClass={`${styles.profileInputClass} fs-exclude`}
                  wrapperClassName={`fs-unmask ${styles.createAccountPreferredName}`}
                />
              </div>
              <div className={styles.inputWrap}>
                <DateTextField
                  {...register('date_of_birth')}
                  label="Date of birth"
                  data-testid="dependent-date-of-birth"
                  value={watch('date_of_birth') ? dayjs(watch('date_of_birth')) : null}
                  errors={errors.date_of_birth ? errors : {}}
                  name="date_of_birth"
                  onChange={(newValue: any) => {
                    if (errors.date_of_birth) clearErrors('date_of_birth');

                    let formattedDate = '';
                    if (newValue) {
                      formattedDate = dayjs(newValue).format('MM/DD/YYYY');
                    }

                    setValue('date_of_birth', formattedDate, { shouldValidate: true });
                  }}
                  required
                  inputClass={`${styles.profileInputClass} fs-exclude`}
                  wrapperClassName={`fs-unmask ${styles.completeProfileDOB}`}
                />
              </div>
            </div>
            <div className={styles.inputWrapRow}>
              <div className={styles.inputWrap}>
                <TextField
                  {...register('dependent_email')}
                  label="Email"
                  data-testid="dependent-email"
                  value={watch('dependent_email')}
                  errors={errors.dependent_email ? errors : {}}
                  name="dependent_email"
                  onChange={(e: any) => {
                    if (errors.dependent_email) clearErrors('dependent_email');
                    setValue('dependent_email', e.target.value, { shouldValidate: true });
                  }}
                  inputClass={`${styles.profileInputClass} fs-exclude`}
                  wrapperClassName={`fs-unmask ${styles.createAccountPreferredName}`}
                />
              </div>
              <div className={`${styles.inputWrap} ${styles.inputWrapPhoneInput}`}>
                <PhoneInput
                  {...register('phone_number')}
                  value={watch('phone_number') as E164Number}
                  id="phone_number"
                  data-testid="dependent-phone-number"
                  name="phone_number"
                  onChange={(val: string | undefined) => {
                    if (val === undefined || val === '') {
                      setValue('phone_number', '', { shouldValidate: true });
                      return;
                    }
                    if (errors.phone_number) clearErrors('phone_number');
                    setValue('phone_number', val, { shouldValidate: true }); // Store in E.164 format
                  }}
                  label="Phone number"
                  errors={errors}
                  inputClass={`${styles.profileInputClass} fs-exclude`}
                  wrapperClassName={`fs-unmask ${styles.completeProfilePhone}`}
                />
              </div>
            </div>
            <div className={styles.inputWrapRow}>
              <div className={styles.inputWrap}>
                <MUISelectInput
                  {...register('gender')}
                  label="Gender assigned at birth"
                  data-testid="dependent-gender"
                  errors={errors.gender ? errors : {}}
                  value={watch('gender') || ''}
                  name="gender"
                  onChange={(e: any) => {
                    if (errors.gender) clearErrors('gender');
                    setValue('gender', e, { shouldValidate: true });
                  }}
                  required
                  inputClass={`${styles.profileInputClass} fs-exclude`}
                  wrapperClassName={`fs-unmask ${styles.completeProfileClassGender}`}
                  options={genderOptions}
                />
              </div>
              <div className={styles.inputWrap}>
                <MUISelectInput
                  {...register('gender_identity')}
                  label="Gender identity"
                  data-testid="dependent-gender-identity"
                  value={watch('gender_identity') || ''}
                  errors={errors.gender_identity ? errors : {}}
                  name="gender_identity"
                  onChange={(e: any) => {
                    if (errors.gender_identity) clearErrors('gender_identity');
                    setValue('gender_identity', e);
                  }}
                  required
                  inputClass={`${styles.profileInputClass} fs-exclude`}
                  wrapperClassName={`fs-unmask ${styles.completeProfileClassIdentity}`}
                  options={genderIdentity}
                />
              </div>
              <div className={styles.inputWrap}>
                <MUISelectInput
                  {...register('pronouns')}
                  label="Preferred pronouns (optional)"
                  data-testid="dependent-pronouns"
                  errors={errors.pronouns ? errors : {}}
                  value={watch('pronouns') || ''}
                  name="pronouns"
                  onChange={(e: any) => {
                    if (errors.pronouns) clearErrors('pronouns');
                    setValue('pronouns', e);
                  }}
                  inputClass={`${styles.profileInputClass} fs-exclude`}
                  wrapperClassName={`fs-unmask ${styles.completeProfileClassPronouns}`}
                  options={pronounsOptions}
                />
              </div>
            </div>
            <div className={styles.inputWrapRow}>
              <div className={styles.inputWrap}>
                <MultiSelectInputMUI
                  {...register('language')}
                  label="Languages"
                  data-testid="dependent-language"
                  errors={errors.language ? errors : {}}
                  name="language"
                  onChange={(selectedValues: OptionLanguage[]) => {
                    if (errors.language) clearErrors('language');
                    setValue('language', selectedValues, { shouldValidate: true });
                  }}
                  withId
                  value={
                    Array.isArray(watch('language')) && typeof watch('language')[0] === 'string'
                      ? (watch('language') as string[])
                      : Array.isArray(watch('language')) && typeof watch('language')[0] === 'object'
                      ? ((watch('language') as OptionLanguage[]).map((lang: OptionLanguage) =>
                          lang.id?.toString(),
                        ) as string[])
                      : []
                  }
                  required
                  inputClass={`${styles.profileInputClass} fs-exclude`}
                  wrapperClassName={`fs-unmask ${styles.completeProfileLanguage}`}
                  options={languageOptions}
                />
              </div>
            </div>
            <div key={key}>
              <div className={styles.optional}>
                <div className={`${styles.checkInput} ${styles.deoendentCheckInput}`}>
                  <div className="form-check m-0 pl-0">
                    <Checkbox
                      checked={isSameAddressAsGuardian}
                      onChange={(e) => selectSameAsGuardian(e.target.checked)}
                      id="optionalInput"
                      data-testid="dependent-same-address-checkbox"
                      disabled={!guardianPatient?.address?.address1}
                    />
                    <label
                      className={styles.optionalLabel}
                      htmlFor="optionalInput"
                      data-testid="dependent-same-address-label"
                    >
                      Same address as guardian
                    </label>
                  </div>
                </div>
              </div>
              <div className={`${styles.formContainer} ${styles.row}`}>
                <AddressSection
                  register={register}
                  errors={errors}
                  getValues={getValues}
                  setTextValue={setTextValue}
                  setValue={setValue}
                  showValidationAddressModal={showValidationAddressModal}
                  clearErrors={clearErrors}
                  watch={watch}
                  required
                />
              </div>
              <div className={styles.inputWrapRow}>
                <div className={styles.inputWrap}>
                  <MUISelectInput
                    {...register('guardian_relationship')}
                    label="Guardians relationship to dependent"
                    errors={errors.guardian_relationship ? errors : {}}
                    name="guardian_relationship"
                    onChange={(e: any) => {
                      if (errors.guardian_relationship) clearErrors('guardian_relationship');
                      setValue('guardian_relationship', e);
                    }}
                    data-testid="dependent-guardian-relationship"
                    value={relationshipOptions.find((option) => option.label === watch('guardian_relationship'))?.value}
                    required
                    guardian_relationship
                    inputClass={`${styles.profileInputClass} fs-exclude`}
                    wrapperClassName={`fs-unmask ${styles.completeProfileClass}`}
                    options={relationshipOptions}
                  />
                </div>
                <div className={styles.inputWrap}>
                  <MUISelectInput
                    {...register('insurance_through')}
                    label="Insured by"
                    errors={errors.insurance_through ? errors : {}}
                    name="insurance_through"
                    data-testid="dependent-insurance-through"
                    onChange={(e: any) => {
                      if (errors.insurance_through) clearErrors('insurance_through');
                      setValue('insurance_through', e);
                    }}
                    value={watch('insurance_through')}
                    required
                    inputClass={`${styles.profileInputClass} fs-exclude`}
                    wrapperClassName={`fs-unmask ${styles.completeProfileClass}`}
                    options={insuranceThroughOptions}
                  />
                </div>
              </div>
            </div>
            {watch('insurance_through')?.toLowerCase() !== 'none' &&
              watch('insurance_through')?.toLowerCase() !== '' && (
                <div className={`${styles.formContainer} ${styles.insuranceContainer}`}>
                  <div className={styles.insuranceWrapper}>
                    <InsuranceFormSection
                      isSecondary={false}
                      phoneInputRef={phoneInputRef}
                      register={register as unknown as UseFormRegister<InsuranceForm>}
                      errors={errors}
                      setValue={setValue as unknown as UseFormSetValue<InsuranceForm>}
                      watch={watch as unknown as UseFormWatch<InsuranceForm>}
                      getValues={getValues as unknown as UseFormGetValues<InsuranceForm>}
                      handleChange={handleChange}
                      handleDragOver={handleDragOver}
                      handleDrop={handleDrop}
                      handleDragEnter={handleDragEnter}
                      handleDragLeave={handleDragLeave}
                      isDragging={isDragging}
                      deleteMedia={deleteMedia}
                      images={images}
                    />
                    {addSecondaryInsurance && (
                      <InsuranceFormSection
                        isSecondary
                        phoneInputRef={phoneInputRef}
                        register={register as unknown as UseFormRegister<InsuranceForm>}
                        errors={errors}
                        setValue={setValue as unknown as UseFormSetValue<InsuranceForm>}
                        watch={watch as unknown as UseFormWatch<InsuranceForm>}
                        getValues={getValues as unknown as UseFormGetValues<InsuranceForm>}
                        handleChange={handleChange}
                        handleDragOver={handleDragOver}
                        handleDrop={handleDrop}
                        handleDragEnter={handleDragEnter}
                        handleDragLeave={handleDragLeave}
                        isDragging={isDragging}
                        deleteMedia={deleteMedia}
                        images={images}
                      />
                    )}
                    <button
                      type="button"
                      className={styles.addSecondaryInsuranceButton}
                      onClick={() => {
                        if (addSecondaryInsurance && patientInsurance && patientInsurance.length > 0) {
                          const insurance = patientInsurance.find((i) => i.is_secondary);

                          if (insurance) {
                            removeSecondaryInsurance(Number(insurance.id));
                          }
                        }
                        setAddSecondaryInsurance(!addSecondaryInsurance);
                      }}
                      data-testid="insurance-add-secondary-insurance"
                    >
                      {!addSecondaryInsurance ? (
                        <div className={styles.addButton}>
                          <FiPlus className={styles.addIcon} />
                          Add Secondary Insurance
                        </div>
                      ) : (
                        <div className={styles.removeButton}>
                          <FiMinus className={styles.addIcon} />
                          Remove Secondary Insurance
                        </div>
                      )}
                    </button>
                  </div>
                </div>
              )}
            {!isFromPatientIntake ? (
              <div className={`${styles.buttonDiv}`}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  data-testid="dependent-save-changes"
                  className={`fs-unmask ${styles.formBtn}`}
                  style={{ borderRadius: '32px', height: '42px', width: 'auto' }}
                  disabled={
                    !dependentFormBaselineReady ||
                    (isEqual(dependentProfileForm, watch()) && isEqual(avatarAction, '')) ||
                    isSavingProfile ||
                    fetchLoading
                  }
                >
                  {isFromSelectPatient && !isEditInsuranceFlag
                    ? 'Continue'
                    : isFromSelectPatient && isEditInsuranceFlag && !isEqual(dependentProfileForm, watch())
                    ? (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
                        CaseType.care_coordination && !needsPayment(currentOrganizationPrice)
                      ? 'Save changes'
                      : 'Continue'
                    : 'Save changes'}
                </Button>
                {!patientPlanId && (
                  <Button
                    type="button"
                    variant="text"
                    color="error"
                    className="fs-unmask"
                    data-testid="dependent-delete-dependent"
                    style={{ borderRadius: '32px', height: '42px', width: 'auto' }}
                    onClick={() => setShowDeleteDependentConfirmationModal?.(true)}
                  >
                    Delete Dependent
                  </Button>
                )}
              </div>
            ) : (
              <div className={`${styles.buttonDiv}`}>
                <Button
                  variant="text"
                  className={styles.patientSelectFooterBack}
                  onClick={() => roleNavigate('/select-patient')}
                >
                  <ArrowBackIosNewIcon />
                  Back
                </Button>
                <Button
                  variant="contained"
                  className={styles.patientSelectFooterNext}
                  type="submit"
                  disabled={
                    !dependentFormBaselineReady ||
                    (isEqual(dependentProfileForm, watch()) && isEqual(avatarAction, '')) ||
                    isSavingProfile ||
                    fetchLoading
                  }
                >
                  Next
                </Button>
              </div>
            )}
          </form>
        </div>
      </div>
      <ConfirmationModal
        title="Confirmation"
        content="Are you sure you want to delete dependent?"
        isOpen={showDeleteDependentConfirmationModal || false}
        onClose={onCloseConfirmationModal}
        onConfirm={onContinueConfirmationModal}
        isSubmitDisabled={isSavingProfile}
      />
      {showModal && !isFromPatientIntake && !isFromCollectorAddDependent && (
        <UnsavedChangesModal
          isOpen={showModal}
          onConfirm={confirmNavigation}
          saveChange={saveChanges}
          hideModal={hideModal}
          loading={fetchLoading}
        />
      )}
    </>
  );
};

EditDependent.defaultProps = {
  dependentId: '',
  isModal: false,
  showDeleteDependentConfirmationModal: false,
  setShowDeleteDependentConfirmationModal: () => {},
};

export default EditDependent;
